import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Base } from '../../primitives/Skeleton/components/Base.js';
import { Circle } from '../../primitives/Skeleton/components/Circle.js';
import { Text } from '../../primitives/Skeleton/components/Text.js';
export const Skeleton = /*#__PURE__*/_styled(({
  variant,
  ...restProps
}) => {
  switch (variant) {
    case 'circle':
      {
        return _jsx(Circle, {
          ...restProps
        });
      }
    case 'text':
      {
        return _jsx(Text, {
          ...restProps
        });
      }
    default:
      {
        return _jsx(Base, {
          ...restProps
        });
      }
  }
}, process.env.NODE_ENV === "production" ? {
  target: "e1izrypj0"
} : {
  target: "e1izrypj0",
  label: "Skeleton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNrZWxldG9uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlCRyIsImZpbGUiOiJTa2VsZXRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCYXNlIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9Ta2VsZXRvbi9jb21wb25lbnRzL0Jhc2UuanMnO1xuaW1wb3J0IHsgQ2lyY2xlIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9Ta2VsZXRvbi9jb21wb25lbnRzL0NpcmNsZS5qcyc7XG5pbXBvcnQgeyBUZXh0IH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9Ta2VsZXRvbi9jb21wb25lbnRzL1RleHQuanMnO1xuZXhwb3J0IGNvbnN0IFNrZWxldG9uID0gc3R5bGVkKCh7IHZhcmlhbnQsIC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgc3dpdGNoICh2YXJpYW50KSB7XG4gICAgICAgIGNhc2UgJ2NpcmNsZSc6IHtcbiAgICAgICAgICAgIHJldHVybiBfanN4KENpcmNsZSwgeyAuLi5yZXN0UHJvcHMgfSk7XG4gICAgICAgIH1cbiAgICAgICAgY2FzZSAndGV4dCc6IHtcbiAgICAgICAgICAgIHJldHVybiBfanN4KFRleHQsIHsgLi4ucmVzdFByb3BzIH0pO1xuICAgICAgICB9XG4gICAgICAgIGRlZmF1bHQ6IHtcbiAgICAgICAgICAgIHJldHVybiBfanN4KEJhc2UsIHsgLi4ucmVzdFByb3BzIH0pO1xuICAgICAgICB9XG4gICAgfVxufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Ta2VsZXRvbi5qcy5tYXAiXX0= */");